import React, { useState } from 'react'
import axios, { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import UserService from '../../../services/User/index'
import { ServerError } from '../../../schemas/Error'

const texts = {
  title: 'Cambiar contraseña',
  message: 'Se enviará un enlace a su correo electrónico para establecer una nueva contraseña. El enlace será válido por 12 horas.',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  success: 'Revisa tu correo para cambiar la contraseña',
  genericError: 'No se pudo enviar el correo. Intente nuevamente.',
}

interface Props {
  open: boolean
  onClose: () => void
}

/** Confirms and triggers a password-change email for the authenticated user. */
export default function ChangePasswordConfirmDialog(props: Props) {
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    if (loading) {
      return
    }
    props.onClose()
  }

  async function handleConfirm() {
    setLoading(true)

    try {
      const userService = new UserService()
      await userService.requestPasswordChange()
      props.onClose()
      toast.success(texts.success)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const serverError = error as AxiosError<ServerError>
        if (serverError?.response?.data?.message) {
          toast.error(serverError.response.data.message)
          return
        }
      }
      toast.error(texts.genericError)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={props.open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{texts.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          {texts.message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default" disabled={loading}>
          {texts.cancel}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" disabled={loading}>
          {texts.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
